import React, { useEffect } from 'react';
import { Col, Modal, Row, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSms, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Loading from 'layouts/public/loading/Loading';
import { IntBox, TextBox } from 'fw/forms';
import { Label } from 'fw/components'
import * as Notifications from 'fw/globals/Notifications';
import * as API from 'modules/app/API';
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import * as App from 'modules/app/App';
import * as Formatting from 'fw/misc/Formatting';
import APICall from 'fw/system/API';
import * as Modals from 'fw/globals/Modals';

const timeDisabled = 1;

class CompleteRegistrationPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            seconds: timeDisabled,
            checkSeconds: false,
            codeSent: false,
            visible: props.visible,
            userRegistrationId: props.userRegistrationId,
            mobilePhone: props.mobilePhone,
            veteranEmail: props.veteranEmail,
            password: props.password,
            amount: props.preQualificationAmount,
            companyFEIN: props.companyFEIN,
            merchantId: props.merchantId,
            paypalClientId: props.paypalClientId,
            paypalFormUrl: props.paypalFormUrl,
            digits: [null, null, null, null, null, null],
            userId: null,
            certificationId: null,
            certificationKey: null,
            vobKey: null,
            stepCode: null,
            paymentAccepted: false,
            paymentAcceptedTransactionId: null,
            loginData: null,
			discountCodeValidated: false,
			discountCodeValid: false,
			discountCode: null,
			discountCodeApplied: null,
			discountAmountApplied: null,
        }
    }

    tick() {
        if (this.state.checkSeconds) {
            if (this.state.seconds === 0) {
                this.setState((prevState) => { 
                    return { 
                        seconds: timeDisabled,
                        checkSeconds: false,
                        busy: false,
                        codeSent: true
                    }; 
                });
            }
            else {
                this.setState((prevState) => { 
                    return { 
                        seconds: prevState.seconds - 1
                    }; 
                });
            }
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => this.tick(), 1000);
    }

    componentWillReceiveProps(nextProps) {
        this.setState((prevState) => { 
            return { 
                visible: nextProps.visible,
                userRegistrationId: nextProps.userRegistrationId,
                mobilePhone: nextProps.mobilePhone,
                veteranEmail: nextProps.veteranEmail,
                amount: nextProps.preQualificationAmount,
                companyFEIN: nextProps.companyFEIN,
                merchantId: nextProps.merchantId,
                paypalFormUrl: nextProps.paypalFormUrl,
                paypalClientId: nextProps.paypalClientId,
                password: nextProps.password
            }; 
        });
    }
	
    validateDigits() {
        const digits = this.state.digits;

        if (digits.some(x => x === undefined || x === null || x === "")) {
            Notifications.error("Please enter all digits.");
            return false;
        }

        return true;
    }

    completeRegistration = () => {
        if (!this.validateDigits())
            return;

        this.setState((prevState) => { 
            return { 
                busy: true
            }; 
        });

        let rq = {
            userRegistrationId: this.state.userRegistrationId,
            validationCode: this.state.digits.join(""),
            password: this.state.password
        };

        // Validate code & complete registration
        API.Security.post('/registration/registerValidation', rq,
            {
                success: (sr) => {
                    this.setState((prevState) => { 
                        return { 
                            userId: sr.data.userId,
                            certificationId: sr.data.certificationId,
                            certificationKey: sr.data.certificationKey,
                            vobKey: sr.data.vobKey,
                            stepCode: sr.data.stepCode,
                            loginData: sr.data.loginData
                        }; 
                    });
                },
                error: (sr) => {
                    Notifications.error(sr.error.errorMessage);
                },
                exception: (sr) => {
                    Notifications.error("Error validating verification code.");
                }
            });

        this.setState((prevState) => { 
            return { 
                busy: false
            }; 
        });
    }

    onChangeDigit = (digit, value) => {
        let digits = this.state.digits;
        digits[digit-1] = value;
        this.setState((prevState) => { return { digits: digits }; })

        if (value)
        {
            switch (digit) {
                case 1:
                    this._digit2 && this._digit2.focus();
                    break;
                case 2:
                    this._digit3 && this._digit3.focus();
                    break;
                case 3:
                    this._digit4 && this._digit4.focus();
                    break;
                case 4:
                    this._digit5 && this._digit5.focus();
                    break;
                case 5:
                    this._digit6 && this._digit6.focus();
                    break;
				default:
					break;
            }
        }
    }

	applyDiscountCodeRequest() {
		return {
			certificationKey: this.state.certificationKey,
			discountCode: this.state.discountCode,
			feeAmount: this.state.amount
		};
	}

	applyDiscountCode = () => {
		const me = this;
		const rq = this.applyDiscountCodeRequest();
		const url = API.DiscountCode.url('/discountCodeSetup/applyDiscountCode');

		new APICall().post(url, rq, {
			success: (r) => {
				Notifications.success(r.message);
				me.setState({ 
					discountCodeValidated: true,
					discountCodeValid: true,
					discountAmountApplied: r.data.discountAmountApplied,
					discountCodeApplied: rq.discountCode
				});
			},
			error: r => {
				me.setState({ 
					discountCodeValidated: true,
					discountCodeValid: false,
					discountAmountApplied: null,
					discountCodeApplied: null
				});
				Notifications.error(r.error.errorMessage);
			}
		})
	}

	submitNoPaymentRequest() {
		return {
			certificationKey: this.state.certificationKey,
			applicationFee: this.state.amount
		};
	}

	submitNoPayment = () => {
		const rq = this.submitNoPaymentRequest();
		API.Certification.post('/certificationSetup/savePreQualificationNoPayment', rq,
			{
				success: (r) => {
					Notifications.success(r.message);
					if (this.state.loginData)
						App.login(this.state.loginData);
					
					this.setState((prevState) => { 
						return { 
							paymentAccepted: true ,
							paymentAcceptedTransactionId: "N/A"
						}; 
					})
				},
				error: (r) => {
					Notifications.error(r.error.errorMessage);
				}
			});
	}

	handleApplyDiscountCode = () => {
		var me = this;

		if (this.state.discountCodeApplied !== null) {
			if (this.state.discountCode !== this.state.discountCodeApplied) {
				Modals.confirm("Do you want to unapply the previously applied Discount Code?",
					function () {
						me.applyDiscountCode();
					},
					function () {
						return;
					}
				);
			}
			else{
				Notifications.success("The Discount Code was already applied");
			}
		}
		else {
			me.applyDiscountCode();
		}
	}

	handleDiscountCodeChange = (value) => {
		this.setState((prevState) => {
			return ({
				discountCode: value
			});
		});
	}

    sendCode = (mode) => {
        this.setState((prevState) => { 
            return { 
                checkSeconds: true,
                busy: true,
                codeSent: false
            }; 
        });

        let rq = {
            userRegistrationId : this.state.userRegistrationId,
            sendMode: mode
        };

        // Send validation code
        API.Security.post('/registration/sendValidationCode', rq,
            {
                success: (sr) => {
                    this.setState((prevState) => { 
                        return { 
                            digits: [null, null, null, null, null, null]
                        }; 
                    });
                },
                error: (sr) => {
                    Notifications.error(sr.error.errorMessage);
                    this.setState((prevState) => { 
                        return {
                            busy: false
                        }; 
                    });
                },
                exception: (sr) => {
                    Notifications.error("Error sending verification code.");
                    this.setState((prevState) => { 
                        return { 
                            busy: false
                        }; 
                    });
                }
            });
    }

    renderValidationModal() {
		const phone = this.state.mobilePhone.number;
        let showMobilePhone = "******" + phone.substring(phone.length - 4);
        let showEmail = this.state.veteranEmail.substring(0, this.state.veteranEmail.indexOf('@')) + "@.....";
        
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-30w">
                <Modal.Header>
                    <h3 style={{ marginTop: "10px", marginBottom: "0px", textAlign:"left", color: '#5592b6' }}>
                        Complete Your Registration
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        {this.state.busy ?
                            <Loading />
                        :
                            <React.Fragment>
                                <Row>
                                    <Col md={12}>
                                        <h4 style={{ marginTop: "0px",  marginBottom: "20px" }}>Select how you would like to receive your validation code.</h4>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6} style={{paddingRight:"20px", textAlign:"right"}}>
                                        <Button 
                                            id='btnSms' 
                                            onClick={(v) => this.sendCode("SMS")}
                                            disabled={this.state.checkSeconds}
                                            bsClass="btn btn-app bg-purple"
                                            style={{width:"150px", height:"200px"}}
                                        >
                                            CODE BY TEXT
                                            <br />
                                            <br />
                                            <br />
                                            <FontAwesomeIcon icon={faSms} size="4x" style={{marginTop:"10px", marginBottom:"10px"}}/>
                                            <br />
                                            <br />
                                            Text me at:
                                            <br />
                                            <b>{showMobilePhone}</b>
                                        </Button>
                                    </Col>
                                    <Col md={6} style={{paddingLeft:"20px", textAlign:"left"}}>
                                        <Button 
                                            id='btnEmail' 
                                            onClick={(v) => this.sendCode("EMAIL")}
                                            disabled={this.state.checkSeconds}
                                            bsClass="btn btn-app bg-olive"
                                            style={{width:"150px", height:"200px"}}
                                        >
                                            CODE BY E-MAIL
                                            <br />
                                            <br />
                                            <br />
                                            <FontAwesomeIcon icon={faEnvelope} size="4x" style={{marginTop:"10px", marginBottom:"10px"}}/>
                                            <br />
                                            <br />
                                            Email me at:
                                            <br />
                                            <b>{showEmail}</b>
                                        </Button>
                                    </Col>
                                </Row>
                                <Row style={{ margintop: "10px" }}>
                                    { this.state.codeSent ?
                                        <Col md={12} className="text-center">
                                            <em style={{ color: '#5592b6' }}><b>Code successfully sent!</b> Please check your selected inbox.</em>
                                            <br />
                                            <em style={{ color: "green" }}><b>Didn't receive your code?</b> Resend code by clicking again on one of these options.</em>
                                        </Col>
                                    :
                                        <Col md={12}>
                                            <em>By clicking on one of these options, our system will automatically send you a 6 digit security code.</em>
                                        </Col>
                                    }
                                </Row>
                            </React.Fragment>
                        }
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    { this.state.codeSent ?
                        <Row>
                            <Col className="text-center" sm={3} xs={12}>
                                <p style={{ marginTop: '9px' }}><b>My 6-digit code is:</b></p>
                            </Col>
                            <Col sm={5} xs={12}>
                                <Row>
                                    <Col style={{ paddingLeft: '2px', paddingRight: '2px' }} className="text-center" xs={2}>
                                        <IntBox
                                            style={{ textAlign: 'center' }}
                                            name='digit1'
                                            positiveOnly
                                            onChange={(v) => this.onChangeDigit(1, v)}
                                            ref={(c) => { this._digit1 = c }}
                                            required
                                            maxLength="1"
                                        />
                                    </Col>
                                    <Col style={{ paddingLeft: '2px', paddingRight: '2px' }} className="text-center" xs={2}>
                                        <IntBox
                                            style={{ textAlign: 'center' }}
                                            name='digit2'
                                            positiveOnly
                                            onChange={(v) => this.onChangeDigit(2, v)}
                                            ref={(c) => { this._digit2 = c }}
                                            required
                                            maxLength="1"
                                        />
                                    </Col>
                                    <Col style={{ paddingLeft: '2px', paddingRight: '2px' }} className="text-center" xs={2}>
                                        <IntBox
                                            style={{ textAlign: 'center' }}
                                            name='digit3'
                                            positiveOnly
                                            onChange={(v) => this.onChangeDigit(3, v)}
                                            ref={(c) => { this._digit3 = c }}
                                            required
                                            maxLength="1"
                                        />
                                    </Col>
                                    <Col style={{ paddingLeft: '2px', paddingRight: '2px' }} className="text-center" xs={2}>
                                        <IntBox
                                            style={{ textAlign: 'center' }}
                                            name='digit4'
                                            positiveOnly
                                            onChange={(v) => this.onChangeDigit(4, v)}
                                            ref={(c) => { this._digit4 = c }}
                                            required
                                            maxLength="1"
                                        />
                                    </Col>
                                    <Col style={{ paddingLeft: '2px', paddingRight: '2px' }} className="text-center" xs={2}>
                                        <IntBox
                                            style={{ textAlign: 'center' }}
                                            name='digit5'
                                            positiveOnly
                                            onChange={(v) => this.onChangeDigit(5, v)}
                                            ref={(c) => { this._digit5 = c }}
                                            required
                                            maxLength="1"
                                        />
                                    </Col>
                                    <Col style={{ paddingLeft: '2px', paddingRight: '2px' }} className="text-center" xs={2}>
                                        <IntBox
                                            style={{ textAlign: 'center' }}
                                            name='digit6'
                                            positiveOnly
                                            onChange={(v) => this.onChangeDigit(6, v)}
                                            ref={(c) => { this._digit6 = c }}
                                            required
                                            maxLength="1"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col className="text-right" sm={4} xs={12}>
                                <Button id="btnCompleteRegistration" type="submit" onClick={this.completeRegistration} bsStyle="primary" disabled={this.state.busy}>Submit</Button>
                            </Col>
                        </Row>
                    : null }
                </Modal.Footer>
            </Modal>
        )
    }

    createPaypalOrder(data, actions) {
        const currency = "USD";

		return actions.order.create({
			intent: "CAPTURE",
			purchase_units: [{
				description: "NVBDC Pre-Qualification fee for Company FEIN " + this.state.companyFEIN,
                reference_id: this.state.certificationId,
				business: this.state.merchantId,
				amount: {
					currency_code: currency,
					value: this.state.amount - this.state.discountAmountApplied,
                    breakdown: {
                        item_total: { 
                            currency_code: currency, 
                            value: this.state.amount - this.state.discountAmountApplied
                        }
                    }
				},
                items: [{
                      name: this.state.certificationId,
                      unit_amount: {
                        currency_code: currency,
                        value: this.state.amount - this.state.discountAmountApplied
                      },
                      quantity: 1
                }],
			}]
		});
	}

	async onPaypalApprove(data, actions) {
		const order = await actions.order.capture();
        
        // Load app state
        if (this.state.loginData)
        {
            App.login(this.state.loginData);
            this.savePayment(this.state.vobKey, this.state.companyFEIN, order);
        }
        else
        {
            this.setState((prevState) => { 
                return { 
                    paymentAccepted: true ,
                    paymentAcceptedTransactionId: order && order.purchase_units[0] && order.purchase_units[0].payments && order.purchase_units[0].payments.captures[0] ? order.purchase_units[0].payments.captures[0].id : ""
                }; 
            })
        }
	}

    savePayment = (vobKey, vobFeinKey, order) => {
        var rq = {
            vobKey: vobKey !== undefined ? vobKey : null,
            vobFeinKey: vobFeinKey !== undefined ? vobFeinKey : null
        };

        API.Certification.post('/certificationSetup/savePreQualificationPayment', rq,
        {
            success: (r) => {
                this.setState((prevState) => { 
                    return { 
                        paymentAccepted: true ,
                        paymentAcceptedTransactionId: order && order.purchase_units[0] && order.purchase_units[0].payments && order.purchase_units[0].payments.captures[0] ? order.purchase_units[0].payments.captures[0].id : ""
                    }; 
                });
            },
            error: (r) => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    onShippingChange(e) {
    }

    onPaypalError(error) {
		console.log(error);
        Notifications.error("An error occurred trying to process your payment.");
	}

    renderPaymentModal() {
        // This values are the props in the UI
        const currency = "USD";
        const style = { "layout" : "vertical" };
        let clientId = this.state.paypalClientId;
        let amount = this.state.amount - this.state.discountAmountApplied;

        // Custom component to wrap the PayPalButtons and handle currency changes
        const ButtonWrapper = ({ currency, showSpinner }) => {
            // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
            // This is the main reason to wrap the PayPalButtons in a new component
            const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

            useEffect(() => {
                dispatch({
                    type: "resetOptions",
                    value: {
                        ...options,
                        currency: currency,
                    },
                });
            }, [currency, showSpinner]);

			return (
                <React.Fragment>
                    { (showSpinner && isPending) && <div className="spinner" /> }
                    <PayPalButtons
                        style={style}
                        disabled={false}
                        forceReRender={[amount, currency, style]}
                        fundingSource={undefined}
                        createOrder={(data, actions) => this.createPaypalOrder(data, actions)}
                        onApprove={(data, actions) => this.onPaypalApprove(data, actions)}
                        onError={(err) => this.onPaypalError(err)}
                        onShippingChange={(v) => this.onShippingChange(v)}
                    />
                </React.Fragment>
            );
        }

        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-30w">
                <Modal.Header>
                    <h3 style={{ marginTop: "10px", marginBottom: "0px", textAlign:"left", color: '#5592b6' }}>
                        NVBDC: Application ID {this.state.certificationId}
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        {this.state.busy ?
                            <Loading />
                        :
                            <React.Fragment>
								<Row>
									<Col md={12}>
										<Label>If you have a Discount Code please enter it and click Apply</Label>
									</Col>
								</Row>
								<Row style={{ marginTop: '10px' }}>
									<Col md={4}>
										<TextBox
											name="discountCode"
											placeholder="Enter Discount Code"
											onChange={this.handleDiscountCodeChange}
											maxLength={20} />
									</Col>
									<Col md={2}>
										<Button bsStyle="primary" onClick={this.handleApplyDiscountCode} style={{ marginLeft: '-20px' }}>Apply</Button>
									</Col>
									<Col md={6}>
										{this.state.discountCodeValidated && this.state.discountCodeValid &&
											<React.Fragment>
												<FontAwesomeIcon icon={['fas', 'check']} size="2x" style={{ color: 'green', textAlign: 'left', marginLeft: '-40px', marginTop: '3px' }} className="my-icon" />
												<b style={{ color: 'green', marginLeft: '5px' }}>The code is valid</b>
											</React.Fragment>
										}
										{this.state.discountCodeValidated && !this.state.discountCodeValid && 
											<React.Fragment>
												<FontAwesomeIcon icon={['fas', 'times']} size="2x" style={{ color: 'red', textAlign: 'left', marginLeft: '-40px', marginTop: '3px' }} className="my-icon" />
												<b style={{ color: 'red', marginLeft: '5px' }}>The code is NOT valid</b>
											</React.Fragment>
										}
									</Col>
								</Row>
								<Row style={{ marginTop: '15px' }}>
									<Col md={12}>
										{this.state.discountCodeValid &&
											<React.Fragment>
												<p style={{ fontSize: '20px' }}>
													A Fee of <strong>${this.state.amount}</strong> is required. 
												</p>
												<p style={{ fontSize: '20px' }}>
													A Discount of <strong>${this.state.discountAmountApplied}</strong> will be applied
												</p>
											</React.Fragment>
										}
										<p style={{ fontSize: '20px' }}>
											A Payment Fee of <strong>${this.state.amount - this.state.discountAmountApplied}</strong> is required to Submit your Application
										</p>
									</Col>
								</Row>
								{this.state.amount - this.state.discountAmountApplied > 0 &&
									<React.Fragment>
										<Row>
											<Col xs={12} sm={8}>
												<Label>Please select your Payment Type below</Label>
											</Col>
											<Col xs={12} sm={4} className="text-right">
												<Label>
													<b>{Formatting.formatCurrency(this.state.amount - this.state.discountAmountApplied)} USD</b>
												</Label>
											</Col>
										</Row>
										<Row>
											<Col md={12}>
												<br />
											</Col>
										</Row>
										<Row>
											<Col md={12} className="text-center">
												{ clientId ?
													<div style={{ maxWidth: "750px", minHeight: "200px" }}>
														<PayPalScriptProvider
															options={{
																"client-id": clientId,
																locale: "en_US",
																"disable-funding": "credit",
																components: "buttons",
																currency: currency
															}}
														>
															<ButtonWrapper
																currency={currency}
																showSpinner={true}
															/>
														</PayPalScriptProvider>
													</div>
												: null }
											</Col>
										</Row>
									</React.Fragment>
								}
								{this.state.discountCodeValidated && this.state.discountCodeValid && this.state.amount - this.state.discountAmountApplied === 0 &&
									<Row style={{ marginTop: '10px' }}>
										<Col md={12}>
											<Label>Please press the button below to Submit your Application</Label>
											<br />
											<br />
											<Button bsStyle="success" onClick={this.submitNoPayment}>Submit</Button>
										</Col>
									</Row>
								}
                            </React.Fragment>
                        }
                    </React.Fragment>
                </Modal.Body>
            </Modal>
        )
    }

    goToApp = (vobKey) => {
        this.getBusy();

        let goToUrl = "/certification/preQualificationPaymentAccepted/" + vobKey;
        window.location.href = goToUrl;
    }

    goToLogin = (loginUrl) => {
        this.getBusy();
        App.logout();
        window.location.href = loginUrl;
    }

    renderPaymentAcceptedModal() {
        let loginUrl = "/public/login";
        
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-30w">
                <Modal.Header>
                    <h3 style={{ marginTop: "10px", marginBottom: "0px", textAlign:"left", color: '#5592b6' }}>
                        Success: Your payment was accepted
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        {this.state.busy ?
                            <Loading />
                        :
                            <React.Fragment>
                                <Row>
                                    <Col xs={12} sm={12} className="text-center">
                                        <FontAwesomeIcon icon={faEnvelope} size="6x" style={{marginTop:"10px", marginBottom:"10px"}}/>
                                        <br />
                                        <br />
                                        An email will be sent to your email address on File
                                        <br />
                                        <br />
                                        <br />
                                        <h4>Application ID: <b style={{ color: '#5592b6' }}>{this.state.certificationId}</b></h4>
                                        <h4>Transaction ID: <b style={{ color: '#5592b6' }}>{this.state.paymentAcceptedTransactionId}</b></h4>
                                        <br />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <br />
                                    </Col>
                                </Row>
                            </React.Fragment>
                        }
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    { this.state.loginData ?
                        <Row>
                            <Col className="text-left" xs={6}>
                                <Button id="btnReturnLater" 
                                    onClick={(v) => this.goToLogin(loginUrl)}
                                    bsStyle="default" >
                                        Return Later
                                </Button>
                            </Col>
                            <Col className="text-right" xs={6}>
                                <Button id="btnGoToApp" 
                                    bsStyle="primary"
                                    onClick={(v) => this.goToApp(this.state.vobKey)}>
                                        Start Application
                                </Button>
                            </Col>
                        </Row>
                    :
                        <Row>
                            <Col className="text-right" xs={12}>
                                <Button id="btnGoToLogin" 
                                    onClick={this.getBusy}
                                    href={loginUrl}
                                    bsStyle="primary" >
                                        Go To Login
                                </Button>
                            </Col>
                        </Row>
                    }
                </Modal.Footer>
            </Modal>
        )
    }

    getBusy = () => {
        this.setState({
            busy: true
        });
    }

    render() {
        let certificationCreated = this.state.certificationId !== null && this.state.certificationId !== undefined;
        
        if (certificationCreated){
            if (this.state.paymentAccepted)
                return this.renderPaymentAcceptedModal();
            else
                return this.renderPaymentModal();
        }
        else
            return this.renderValidationModal();
    }
}

export default CompleteRegistrationPopUp;


// WEBPACK FOOTER //
// ./src/areas/public/registration/CompleteRegistrationPopUp.js